// src/components/ResetPasswordPage.tsx

import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthContext';
import './AuthPage.scss';
import { useNavigate, useLocation } from 'react-router-dom';

const ResetPasswordPage: React.FC = () => {
  const { resetPassword } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Prepopulate username if passed from ForgotPasswordPage
  const state = location.state as { email?: string };
  useState(() => {
    if (state?.email) {
      setEmail(state.email);
    }
  });

  const handleResetPassword = async () => {
    if (!email || !verificationCode || !newPassword) {
      setError('Please fill out all fields.');
      return;
    }

    try {
      await resetPassword(email, verificationCode, newPassword);
      // Redirect to sign-in page after successful password reset
      navigate('/login');
    } catch (err) {
      setError('Failed to reset password. Please check your details and try again.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h2>Reset Password</h2>
        {error && <p className="error-message">{error}</p>}
        <div className="form-group">
          <label>Email</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Username"
          />
        </div>
        <div className="form-group">
          <label>Verification Code</label>
          <input
            type="text"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            placeholder="Enter code sent to your email"
          />
        </div>
        <div className="form-group">
          <label>New Password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="New Password"
          />
        </div>
        <button className="cta-button" onClick={handleResetPassword}>
          Set New Password
        </button>
        <div className="additional-links">
          <a href="/signin">Go back to Sign In</a>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
